<template>
  <footer class="app-footer">
    <ul>
      <li>
        <a href="https://ten-eight.site/" target="_blank">運営会社</a>
      </li>
    </ul>
  </footer>
</template>
